module.exports = __webpack_public_path__ + "assets/icon-search-blue-border.8ecd6e58.svg";